import React from 'react';
//Para Documentacion
import PropTypes from 'prop-types';
//MUI
import Dialog from '@material-ui/core/Dialog';

/**
 * <p>Contenedor con comportamiento modal para envolver cualquier tipo de contenido.</p>
 * Cualquier otra propiedad proporcionada sera controlada por el elemento raiz [Dialog de Material-UI](https://material-ui.com/api/dialog/)
 */
const DialogBase = (props) => {
   const {containerId, open, onClose, disableBackdropClick, disableEscapeKeyDown, ...other} = props;
   function handleOnClose(e, reason) {
      if (disableBackdropClick && reason === 'backdropClick') {
         return false;
      }

      if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
         return false;
      }

      if (typeof onClose === 'function') {
         onClose(e, reason);
      }
   }
   let dialogProps = {
      open: open,
      onClose: handleOnClose
   };

   if (containerId) {
      dialogProps.style = {position: 'absolute'};
      dialogProps.BackdropProps = {style: {position: 'absolute'}};
      dialogProps.container = document.getElementById(containerId);
   }

   return (
      <Dialog {...other} {...dialogProps} aria-labelledby="form-dialog">
         {props.children}
      </Dialog>
   );
};

DialogBase.propTypes = {
   /**
    * Si es true el modal se encuentra abierto.
    */
   open: PropTypes.bool.isRequired,
   /**
    * Función a ejecutar cuando se cierra el modal.
    */
   onClose: PropTypes.func,
   /**
    * Elementos a renderizar dentro del modal.
    * Todos los elementos entre los tags de DialogBase son pasados automaticamente en la propiedad children.
    */
   children: PropTypes.node,
   /**
    * Indica el id del contenedor sobre el que el modal se abrira.
    */
   containerId: PropTypes.string,
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se haga click fuera del modal.
    */
   disableBackdropClick: PropTypes.bool,
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se presione la tecla *escape*.
    */
   disableEscapeKeyDown: PropTypes.bool
};

DialogBase.defaultProps = {
   disableBackdropClick: false,
   disableEscapeKeyDown: false
};

export default DialogBase;
